import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import cardBg from 'assets/images/xmas/bg-lt.png';

const LotteryHomeStyle = {
    wrap: css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 12px;
        @media (max-width: 960px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 540px) { grid-template-columns: 1fr; }
    `,
    card: css`
        min-width: 0;
        padding: 12px;
        border: 1px solid #00a6aa;
        border-radius: 8px;
        background: linear-gradient(135deg, rgba(20, 54, 67, .96), rgba(7, 25, 38, .98)), url(${cardBg}) center / cover;
        color: ${colors.white};
        box-shadow: inset 0 1px 0 rgba(255,255,255,.08);
        transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
        &:hover { transform: translateY(-4px); border-color: ${colors.secondary}; box-shadow: 0 12px 22px rgba(0,0,0,.2); }
    `,
    top: css`
        display: flex;
        align-items: center;
        img {
            width: 34px;
            height: 34px;
            object-fit: contain;
        }
    `,
    issue: css`
        margin-left: 6px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        p {
            font-size: 12px;
            color: #f4d681;
        }
        h6 {
            max-width: 180px;
            overflow: hidden;
            font-size: 14px;
            font-weight: 700;
            text-overflow: ellipsis;
            text-transform: uppercase;
            white-space: nowrap;
        }
    `,
    result: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 16px 0;
        > div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            min-width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid rgba(255, 241, 192, .95);
            background: linear-gradient(145deg, #fff9df, #ffc857);
            color: #12294f;
            box-shadow: 0 0 0 2px rgba(255, 200, 87, .16), 0 4px 10px rgba(0, 0, 0, .24);
            font-size: 19px;
            font-weight: 800;
            line-height: 1;
            overflow: hidden;
            position: relative;
        }
    `,
    bottom: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn-play {
            border-color: #ffad33;
            border-width: 1px;
            border-style: solid;
            padding: 0 17px;
            color: #ffffff;
            height: 34px;
            background: rgba(255, 173, 51, .1);
            font-size: 11px;
            font-family: 'Lato', sans-serif;
            font-weight: bold;
            border-radius: 100px;
            transition: background 160ms ease, color 160ms ease;
            &:hover { background: ${colors.secondary}; color: ${colors.blackText}; }
        }
    `,
    timer: css`
        font-size: 10px;
    `,
    btnNavigate: css`
        display: none;
        &:disabled {
            opacity: 0.5;
            cursor: initial;
        }
        svg {
            width: 40px;
            height: 40px;
            polyline {
                stroke: ${colors.orange};
            }
        }
    `,
    btnPrev: css`
        left: -20px;
    `,
    btnNext: css`
        right: -20px;
    `,
};
export default LotteryHomeStyle;
